module.exports = __webpack_public_path__ + "static/img/banner-2.902c3b0e.png";